import { yupResolver } from '@hookform/resolvers/yup'
import { useSignupFormDefaultValues } from 'modules/auth/hooks/useSignupFormDefaultValues'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { validatePassword } from 'modules/common/lib/validation/password'
import {
  rEmail,
  rWithAcceptedCharacters,
} from 'modules/common/lib/validation/rules'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

export interface SignupFormData {
  firstname: string
  lastname: string
  email: string
  password: string
  userAcceptsTerms: boolean
  hasConsentedForMarketing: boolean
  hasConsentedForThirdPartyCommunication: boolean
  allOptionalConsent: boolean
  userAcceptsCommercialSolicitation?: boolean
  captchaToken: string | null
}

export const useSignupForm = () => {
  const { t } = useTranslation('auth-components')
  const signupFormDefaultValues = useSignupFormDefaultValues()

  const schema = yup.object().shape({
    firstname: yup
      .string()
      .required(t('signupForm.name.firstname.errors.required'))
      .matches(
        rWithAcceptedCharacters,
        t('signupForm.name.firstname.errors.format')
      ),
    lastname: yup
      .string()
      .required(t('signupForm.name.lastname.errors.required'))
      .matches(
        rWithAcceptedCharacters,
        t('signupForm.name.lastname.errors.format')
      ),
    email: yup
      .string()
      .required(t('signupForm.email.errors.required'))
      .matches(rEmail, t('signupForm.email.errors.format')),
    password: validatePassword,
    userAcceptsTerms: yup.bool().oneOf([true]),
    allOptionalConsent: yup.bool(),
    hasConsentedForMarketing: yup.bool(),
    hasConsentedForThirdPartyCommunication: yup.bool(),
  })

  return useForm<SignupFormData>({
    resolver: yupResolver(schema),
    mode: 'all',
    criteriaMode: 'all',
    reValidateMode: 'onChange',
    defaultValues: signupFormDefaultValues,
  })
}
